// model/constants.ts
export const bodyFatGoals = [
  {
    range: "4%~6%",
    title: "Отличная цель!",
    description:
      "Постепенно! Эта цель вполне выполнима, в том числе и для новичков",
    isSafe: true,
  },
  {
    range: "7%~10%",
    title: "Отличная цель",
    description:
      "Поддерживать этот уровень поможет сбалансированный образ жизни",
    isSafe: true,
  },
  {
    range: "11%~15%",
    title: "Неплохо!",
    description: "Вы в целевой зоне. Продолжайте!",
    isSafe: true,
  },
  {
    range: "16%~23%",
    title: "Отличная цель!",
    description:
      "Постепенно! Эта цель вполне выполнима, в том числе и для новичков",
    isSafe: true,
  },
  {
    range: "24%~30%",
    title: "Проконсультруйтесь с врачом",
    description:
      "Этот уровень жира в теле высоковат для вас, и это может привести к определенным проблемам со здоровьем",
    isSafe: false,
  },

  {
    range: "31%~40%",
    title: "Проконсультруйтесь с врачом",
    description:
      "Этот уровень жира в теле высоковат для вас, и это может привести к определенным проблемам со здоровьем",
    isSafe: false,
  },

  {
    range: ">40%",
    title: "Проконсультруйтесь с врачом",
    description:
      "Этот уровень жира в теле высоковат для вас, и это может привести к определенным проблемам со здоровьем",
    isSafe: false,
  },
];
